import React from 'react';
import {FeaturePopover} from './FeaturePopover';
import {initFeatureMap} from './constants/map';

export const featurePopoverRef: React.RefObject<FeaturePopover> = React.createRef();

export async function renderFeaturePopover(root) {
    await initFeatureMap();

    root.render(<FeaturePopover ref={featurePopoverRef} />);

    return featurePopoverRef;
}
